module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/jiantou-68cce4751425e1b9478fc569686ff06e.gif";